export function isExternalLink(url) {
  return /^(https?:)?\/\/|^(mailto|tel):/i.test(url);
}
